
<template lang="html">



    <div>
        <button id="myButton" title="Ingresa Comentario" @click="movimientoPop" class="foo bar"> <v-icon :color="'#B3C9F1'"> {{'mdi-file-document-edit'}}</v-icon></button>
       
        <div class="col align-self-center">
            <vs-popup title="Alta Movimiento" fullscreen :active.sync="val">
                <div class="container-fluid">

                    <div class="row">

                        <div class="col-md-12 col-sm-12 col-xs-12">
                            <vs-divider>
                                <h5>Movimiento</h5>
                            </vs-divider>
                        </div>

                        <div class="col-12 col-sm-12 col-md-12">
                            <div class="row" v-if="active5">
                                <div class="col-md-3 col-sm-3 col-xs-12"></div>
                                <div class="col-md-6 col-sm-6 col-xs-12">
                                    <span style="text-align:center;"><strong>Reporte: </strong>{{datos.reporte}}-{{datos.indice}}</span>

                                </div>
                                <div class="col-md-3 col-sm-3 col-xs-12">
                                </div>
                            </div>
                            <div class="row" v-if="active5">
                                <div class="col-md-3 col-sm-3 col-xs-12"></div>
                                <div class="col-md-6 col-sm-6 col-xs-12">
                                    <span style="text-align:center;">Movimiento:</span>
                                    <multiselect v-model="datos.ceclave"
                                                 deselect-label="No se puede remover el valor seleccionado"
                                                 selected-label="Seleccionado"
                                                 select-label="Seleccione Movimiento"
                                                 track-by="ceclave" label="ceconcepto"
                                                 placeholder="Seleccione Movimiento"
                                                 :options="opciones" :allow-empty="false">
                                    </multiselect>
                                </div>
                                <div class="col-md-3 col-sm-3 col-xs-12"></div>
                            </div>
                            <div class="row" v-if="active5">
                                <div class="col-md-3 col-sm-3 col-xs-12">
                                </div>
                                <div class="col-md-6 col-sm-6 col-xs-12" style="margin-top:20px">
                                    <span style="text-align:center;">Observaciones:</span>
                                    <vs-textarea rows="7"
                                                 class="code"
                                                 @input="uppercase()"
                                                 style="height: 147px;"
                                                 counter="500"
                                                 :counter-danger.sync="counterDanger"
                                                 v-model="datos.observaciones"
                                                 maxlength="500" />
                                </div>
                                <div class="col-md-3 col-sm-2 col-xs-12">
                                    <!--<vs-alert :active.sync="active1"
                                              closable
                                              close-icon="close">
                                        Lorem ip
                                        sum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
                                    </vs-alert>-->
                                </div>
                            </div>
                            <div class="row" v-if="active4">
                                <div class="col-md-3 col-sm-3 col-xs-12">
                                </div>
                                <div class="col-md-6 col-sm-6 col-xs-12" style="margin-top:20px">
                                    <vs-alert title="Error: Faltan Campos por llenar" :active.sync="active4" color="danger">
                                        <span style="font-size: 15px;">{{mensajeMov}}</span>

                                        <br>
                                        <span style="font-size: 15px;">{{mensajeObs}}</span>

                                        <br>
                                    </vs-alert>
                                </div>
                                <div class="col-md-3 col-sm-2 col-xs-12">
                                </div>
                            </div>
                            <div class="row" v-if="active3">
                                <div class="col-md-3 col-sm-3 col-xs-12">
                                </div>
                                <div class="col-md-6 col-sm-6 col-xs-12" style="margin-top:20px">
                                    <vs-alert title="Exito: " :active.sync="active3" color="success">
                                        <span style="font-size: 17px;">El movimiento fue capturado correctamente.</span>


                                    </vs-alert>
                                </div>
                                <div class="col-md-3 col-sm-2 col-xs-12">
                                </div>
                            </div>
                            <div id="scroll"></div>
                        </div>

                    </div>
                </div>
                <input ref="search" disabled />
                <div class="card-footer text-center">
                    <vs-col vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center" style="margin-top: 5px;">
                        <vs-button @click="GuardarSeguimiento()" :disabled="disabledSave" color="primary">Aceptar</vs-button>
                        <vs-button color="danger" @click="Cancelar()" :disabled="disabledClean" type="filled" style="margin-left: 5px;">Cancelar</vs-button>
                    </vs-col>
                    

                </div>
            </vs-popup>
        </div>
    </div>

</template>

<script>
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import reporte from '@/services/Reporte/reporte.service.js';

    export default {
        
        props: {
            nrreporte: String,
            pantalla: String,
            pantallaMovimiento: {
                type: Boolean
            },
        },
        data: () => ({
            uslogin: '',
            val: false,
            active4: false,
            active3: false,
            active5: true,
            mensajeMov: '',
            mensajeObs: '',
            reporteindice: '',
            disabledSave: false,
            disabledClean: false,
            counterDanger: false,

            datos: {
                ceclave: '',
                observaciones: '',
                reporte: '',
                indice: ''
            },
            value: null,
            opciones: []

        }),
        watch: {
            async 'datos.ceclave'(val) {

                if (val.ceclave != '') {
                    this.active4 = false;
                }
            },
            async 'datos.observaciones'(val) {

                if (val.length > 0) {
                    this.active4 = false;
                }
            }
        },
        computed: {
            ...mapState(['permission', 'domain']),
            ...mapGetters(['getUser', 'THEME_STATE'])
        },
        methods: {
            movimientoPop() {
                this.active5 = true;
                this.datos.ceclave = '';
                this.datos.observaciones = '';
                this.active4 = false;
                this.active3 = false;
                this.mensajeMov = '';
                this.mensajeObs = '';
                this.val = false;
                this.disabledSave = false;
                this.disabledClean = false;
                this.val = true;
                reporte.obtenerSeguimiento(this);
            },
            uppercase() {
                this.datos.observaciones = this.datos.observaciones.toUpperCase();
            },
            async GuardarSeguimiento() {

                this.mensajeMov = this.datos.ceclave == '' ? '-Selecciona el tipo de movimiento.' : '';
                this.mensajeObs = this.datos.observaciones == '' || this.datos.observaciones.length < 10 ? '-Ingresa observaciones como minimo 10 caracteres.' : '';
                if (this.datos.ceclave != '' && (this.datos.observaciones != '' && this.datos.observaciones.length >= 10)) {

                    this.active4 = false;
                    this.disabledSave = true;
                    this.disabledClean = true;
                    this.$vs.loading();

                    setTimeout(async () => {



                        await reporte.GuardarMovimiento(this, this.datos).then(response => {


                            this.$vs.loading.close();

                            if (response) {


                                this.active5 = false;
                                this.active3 = true;

                                setTimeout(() => {
                                    this.datos.ceclave = '';
                                    this.datos.observaciones = '';
                                    this.active4 = false;
                                    this.active3 = false;
                                    this.mensajeMov = '';
                                    this.mensajeObs = '';
                                    this.val = false;
                                    this.disabledSave = false;
                                    this.disabledClean = false;
                                }, 4000);


                            }
                        });

                    }, 2000);
                } else {
                    this.active4 = true;
                    setTimeout(() => {
                        this.$refs.search.scrollIntoView();
                    }, 50);

                }

            },
            Cancelar() {
                this.datos.ceclave = '';
                this.datos.observaciones = '';
                this.active4 = false;
                this.active3 = false;
                this.mensajeMov = '';
                this.mensajeObs = '';
                this.val = false;
                this.disabledSave = false;
                this.disabledClean = false;

            }

        },
        mounted() {

            this.datos.reporte = this.nrreporte.split('-')[0];
            this.datos.indice = this.nrreporte.split('-')[1];

        },

    }
</script>

<style lang="scss">
    .code input {
        text-transform: uppercase;
    }
</style>
<style scope>
    .header-sidebar {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
    }

        .header-sidebar h4 {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
        }

            .header-sidebar h4 > button {
                margin-left: 10px;
            }

    .footer-sidebar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }

        .footer-sidebar > button {
            border: 0px solid rgba(0,0,0,0) !important;
            border-left: 1px solid rgba(0,0,0,0.07) !important;
            border-radius: 0px !important;
        }

    .vs-sidebar {
        max-width: 350px !important;
    }

        .vs-sidebar.vs-sidebar-parent {
            position: fixed !important;
        }

    .vs-sidebar--background {
        background: none !important;
    }

    /*FLOTANTE  */
    .btn-flotante {
        text-transform: uppercase; /* Texto en mayusculas */
        border-radius: 10px; /* Borde del boton */
        background-color: #747d8c; /* Color de fondo */
        padding: 2px 6px; /* Relleno del boton */
        position: fixed;
        top: 75px;
        right: 6px;
        transition: all 300ms ease 0ms;
        box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
        z-index: 99;
        opacity: 0.5;
    }

        .btn-flotante:hover {
            background-color: #2f3542; /* Color de fondo al pasar el cursor */
            box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.3);
            transform: translateY(-7px);
        }

    @media only screen and (max-width: 600px) {
        .btn-flotante {
            padding: 2px 6px;
        }
    }
</style>